import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, ClipboardList, Users, LogOut, SlidersHorizontal } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/Logo";

const NAV = [
  { to: "/admin", end: true, icon: LayoutDashboard, label: "Tableau de bord", testid: "nav-dashboard" },
  { to: "/admin/demandes", icon: ClipboardList, label: "Demandes", testid: "nav-requests" },
  { to: "/admin/artisans", icon: Users, label: "Artisans", testid: "nav-artisans" },
  { to: "/admin/parametres", icon: SlidersHorizontal, label: "Paramètres", testid: "nav-settings" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = async () => {
    await logout();
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen bg-slate-50 flex" data-testid="admin-layout">
      {/* Sidebar (desktop) */}
      <aside className="hidden lg:flex w-64 flex-col bg-[#0B1E4D] fixed inset-y-0 left-0">
        <div className="h-20 flex items-center px-6 border-b border-white/10">
          <Logo flagClass="h-8" textClass="text-xl" boxed />
        </div>
        <nav className="flex-1 p-4 space-y-1">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={n.testid}
              className={({ isActive }) =>
                `flex items-center gap-3 rounded-lg px-4 py-3 text-sm font-medium transition-colors ${
                  isActive ? "bg-blue-600 text-white" : "text-slate-300 hover:bg-white/5 hover:text-white"
                }`
              }
            >
              <n.icon className="h-4.5 w-4.5" /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-white/10">
          <p className="text-xs text-slate-400 px-2 truncate">{user?.email}</p>
          <Button onClick={doLogout} variant="ghost" className="w-full mt-2 justify-start text-slate-300 hover:bg-white/5 hover:text-white" data-testid="logout-button">
            <LogOut className="h-4 w-4 mr-2" /> Déconnexion
          </Button>
        </div>
      </aside>

      {/* Mobile top bar */}
      <div className="lg:hidden fixed top-0 inset-x-0 z-30 bg-[#0B1E4D] text-white">
        <div className="h-16 flex items-center justify-between px-4">
          <Logo flagClass="h-7" textClass="text-base" boxed />
          <Button onClick={doLogout} variant="ghost" size="sm" className="text-slate-300 hover:text-white" data-testid="logout-button-mobile">
            <LogOut className="h-4 w-4" />
          </Button>
        </div>
        <nav className="flex border-t border-white/10">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              className={({ isActive }) =>
                `flex-1 flex flex-col items-center gap-1 py-2 text-xs font-medium ${isActive ? "text-blue-400" : "text-slate-400"}`
              }
            >
              <n.icon className="h-4 w-4" /> {n.label.split(" ")[0]}
            </NavLink>
          ))}
        </nav>
      </div>

      {/* Content */}
      <main className="flex-1 lg:ml-64 pt-28 lg:pt-0">
        <Outlet />
      </main>
    </div>
  );
}
